<studio-dialog>
  <studio-dialog-title
    text="Are you sure you'd like to delete &quot;{{ data.name }}&quot; from your dashboard?"
  ></studio-dialog-title>
  <studio-dialog-description text="Deleting the project will also delete its deployment.">
  </studio-dialog-description>
  <studio-dialog-buttons-container>
    <studio-dialog-button
      theme="dark-secondary"
      text="Cancel"
      precedence="secondary"
      (click)="cancel()"
    ></studio-dialog-button>
    <studio-dialog-button
      buttonTheme="error"
      text="Delete project"
      precedence="primary"
      (click)="confirm()"
    ></studio-dialog-button>
  </studio-dialog-buttons-container>
</studio-dialog>
